export class Tipologiaservizio {
	id?: number;
	color?: string;
	name?: string;
}